export enum InquirySteps {
    Overview = 0,
    Positions = 1,
    Suppliers = 2,
    DispatchList = 3,
    OffersAndComparison = 4,
}
